<template>
  <Teleport to="body">
    <Modal v-model="show">
      <ModalContent size="xlarge">
        <template #header>
          <Heading level="h2">On call support</Heading>
        </template>

        <div class="tw-h-[70vh] tw-w-full">
          <iframe
            v-if="calendarUrl"
            :src="calendarUrl"
            class="tw-h-full tw-w-full tw-rounded-xl tw-border-0"
            loading="lazy"
          />
        </div>

        <template #footer="{ reject }">
          <Button color="transparent" outlined @click="reject"> Close </Button>
        </template>
      </ModalContent>
    </Modal>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue';

import { Button, Heading, Modal, ModalContent } from '@slideslive/fuse-kit/vue';

const show = defineModel();

const teamCalendarId =
  'Y18wZDUzNDc2ZjVmOGIzMjgyOTQxZDVmZTkzYjQwNjlmM2RhYTMzOTc4NGRjZTMzMTlkODczNDkyYzc0NTA1NDljQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20';
const eventsCalendarId = 'ZmxzdXVlNmdxaGMwMXJlZ3RucjJsZGhwanQ3NmdzamNAaW1wb3J0LmNhbGVuZGFyLmdvb2dsZS5jb20';

const teamCalendarColor = '#9e69af';
const eventsCalendarColor = '#d50000';

const calendarUrl = computed(() => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const baseUrl = 'https://calendar.google.com/calendar/embed';

  const params = new URLSearchParams({
    height: '600',
    wkst: '1',
    showPrint: '0',
    showTz: '0',
    ctz: tz,
  });

  params.append('src', teamCalendarId);
  params.append('color', teamCalendarColor);

  params.append('src', eventsCalendarId);
  params.append('color', eventsCalendarColor);

  return `${baseUrl}?${params.toString()}`;
});
</script>
